import React from "react";
import { connect } from "dva";
import { modelUtils } from '@/utils'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { columns1, columns2 } from "./columns";
import '@/styles/containers/survey/surveyRecordInfo/index.less'
import createExportColumns from "./exportColumns";
import { AudienceGroupItem } from '@/components';
import moment from "moment";

const { WizCard, WizRow, WizCol, WizDataTable, WizTabs, WizSearchBar, WizButton, WizBrowserExport, WizCollapse, WizBizcharts, WizTypography } = component_tool;
const { WizContainer } = framework_tool;
const { getPageData, Session } = utils_tool;
const { Chart, Geom, Axis, Tooltip, Coord, Legend } = WizBizcharts;

const getParamRecord = (history) => {
  let record = {}
  if (history.location && (!history.location.pathname.endsWith("surveyRecordInfoDetail"))){
    if (history.location.record) {
      record = history.location.record
      Session.set('surveyRecordInfo', record);
    } else {
      record = Session.get('surveyRecordInfo') || {}
    }
  }
  return record
}

/**获取表格的内容*/
function getTableData(data) {
  let dataInfo = []
  if (data && data.length) {
    dataInfo = data
    dataInfo.forEach(e => {
      if (e['disabled'] === 0) {
        e['disabled'] = "激活"
      } else {
        e['disabled'] = "禁用"
      }
      if (e['userType'] === 0) {
        e['userType'] = "培训平台用户"
      } else if (e['userType'] === 3) {
        e['userType'] = "OEM部门用户"
      } else if (e['userType'] === 4) {
        e['userType'] = "经销商用户"
      } else if (e['userType'] === 5) {
        e['userType'] = "服务商用户"
      } else {
        e['userType'] = ""
      }
      if (e['questions'] && e['questions'].length) {
        e['questions'].forEach(q => {
          let answerOptions = []
          let title = new Set();
          if (q['answerOptions'] && q['answerOptions'].length) {
            answerOptions = q['answerOptions']
            answerOptions.forEach(a => {
              if (a['content']) {
                title.add(a['content'])
              }
            })
          } else {
            if (q['answer']) {
              title.add(q['answer'])
            }
          }
          if (q['otherAnswer'] && q['otherAnswer'].length) {
            title.add(q['otherAnswer'])
          }
          e[q['title']] = Array.from(title).toString();
        })
      }
    })
  }
  return dataInfo;
}
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

class SurveyRecordInfo extends WizContainer {
  componentName = "SurveyRecordInfo";

  constructor(props) {
    super(props);
    this.buildActionKey();
    const { history } = props;
    this._surveyRecord = getParamRecord(history)
    this.surveyDate = formatterDate(this._surveyRecord.startDate) + " ~ " + formatterDate(this._surveyRecord.endDate);
    this._surveyId = this._surveyRecord.id;
    this.filters = {}
    this.state = {
      targetScopeRecord: { orgIds: [], positionIds: [], positionCategoryIds: [], personIds: [] },
    }
  }

  _componentDidMount = () => {
    this._surveyTargetScopeInfo()
    this._surveyAnswerList()
    // this._surveyResult()
    this._surveyInfo()
  }

  _surveyInfo(apiParams = {}) {
    this.doAction({
      path: 'survey/getSurveyInfo',
      payload: {
        key: 'surveyInfo',
        apiParams: {
          id: this._surveyId,
          ...apiParams
        }
      }
    })
  }

  /**
   * 获取问卷记录
   * @param apiParams
   * @private
   */
  _surveyResult(apiParams = {}) {
    this.doAction({
      path: 'survey/surveyResult',
      payload: {
        key: 'surveyResult@' + this._surveyId,
        apiParams: {
          surveyId: this._surveyId,
          ...apiParams
        }
      }
    })
  }

  propsAndStateOnChange = {
    surveyInfo: this._surveyInfoOver.bind(this),
    surveyAnswerExport: this._surveyAnswerExportOver.bind(this),
    targetScopeInfo: this._targetScopeInfo.bind(this)
  }

  _surveyInfoOver(nextProps, nextState) {
    if (nextProps.surveyInfo.code === 1) {
      nextState.surveyInfo = nextProps.surveyInfo.data
      this._surveyRecord.status = nextProps.surveyInfo.data.status
      return true;
    } else {
      wizNotice.error('获取问卷数据失败')
      return false;
    }
  }


  /**获取导出数据*/
  _surveyAnswerExportOver(nextProps, nextState) {
    let {surveyInfo} = nextState
    if (nextProps.surveyAnswerExport.code === 1) {
      let data = nextProps.surveyAnswerExport.data
      let columnDefs = createExportColumns(this, data,surveyInfo)
      let dataInfo = getTableData(data)
      WizBrowserExport({
        title: '问卷记录信息',
        sheetName: '问卷记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: dataInfo,
        filename: '问卷记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _targetScopeInfo(nextProps, nextState) {
    let { targetScopeInfo } = nextProps
    if (targetScopeInfo && targetScopeInfo['success']) {
      let data = Object.assign({}, targetScopeInfo['data'])
      if (data['orgIds'] && data['orgIds'] instanceof Array) {
        data['orgIds'] = data['orgIds'].reduce((acc, cur, index) => {
          for (let i = 0; i < acc.length; i++) {
            const element = acc[i];
            if (element['categoryId'] === cur['categoryId']) {
              acc[i]['name'] = acc[i]['name'] + ',' + cur['name']
              return acc;
            }
          }
          return acc.concat({ id: cur['id'], name: cur['categoryName'] + ':' + cur['name'], categoryId: cur['categoryId'] })
        }, []);
      }
      data['message'] = [
        `受众人数：${data['scopeCount'] || 0}`,
        `提交人数：${this._surveyRecord.submitUserNumber || 0}`
      ]
      this.setState({
        targetScopeRecord: data,
      });
    } else {
      wizNotice.error(targetScopeInfo && targetScopeInfo['msg'] || '操作失败,请稍后尝试')
    }
    return false
  }

  /**
   * 调查受众
   * @param apiParams
   * @private
   */
  _surveyTargetScopeInfo() {
    this.doAction({
      path: 'survey/targetScopeInfo',
      payload: {
        key: 'targetScopeInfoKey',
        apiParams: { id: this._surveyId }
      }
    });
  }

  /**
   * 查询记录详情
   * @param apiParams
   * @private
   */
  _surveyAnswerList(apiParams = {}) {
    this.doAction({
      path: 'survey/surveyAnswerList',
      payload: {
        key: 'surveyRecordInfo@' + this._surveyId,
        apiParams: {
          surveyId: this._surveyId,
          ...apiParams
        }
      }
    })
  }

  /**导出接口*/
  _surveyAnswerExport(apiParams = {}) {
    let apiPath = "surveyAnswer/surveyAnswerList";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'surveyAnswer@surveyAnswerList',
        apiParams: {
          surveyId: this._surveyId,
          ...apiParams
        }
      }
    })
  }

  _onLook = (record) => {
    this.jumpPage('push', '/biz/survey/surveyRecordInfo/surveyRecordInfoDetail', record)
  }

  // 渲染问卷详情描述部分信息
  renderDiscriptions = () => {
    let surveyStatus = "";
    let surveyStatusColor = { marginLeft: 20, padding: '0 5px', color: '#FFFFFF', backgroundColor: '#BEBEBE' };
    let surveyType = "";
    switch (this._surveyRecord.status) {
      case 1:
        surveyStatus = "已发布";
        surveyStatusColor = { marginLeft: 20, padding: '0 5px', color: '#008B00', backgroundColor: '#B4EEB4' };
        break;
      case 2: surveyStatus = "已结束"; break;
      case 3: surveyStatus = "已关闭"; break;
      default:
        surveyStatus = "草稿";
        break;
    }

    switch (this._surveyRecord.type) {
      case 0: surveyType = "普通问卷"; break;
      case 1: surveyType = "随堂问卷"; break;
      case 2: surveyType = "回执问卷"; break;
      case 3: surveyType = "满意度问卷"; break;
    }
    const arr = [
      { label: '问卷标题：', value: this._surveyRecord.title },
      { label: '问卷类型：', value: surveyType },
      { label: '参与人数：', value: this._surveyRecord.submitUserNumber },
      { label: '开始/结束时间：', value: this.surveyDate },
      { label: '问卷说明：', value: this._surveyRecord.intro }
    ]
    return arr.map((val, index) => {
      return (
        <WizRow key={val.label} type="flex" gutter={[5, 16]}>
          <WizCol span={5} md={3} xs={8} style={{ textAlign: 'right' }}>{val.label}</WizCol>
          {index ?
            <WizCol span={19} md={21} xs={16}>
              <div className='surveyRecordInfo-discriptions'>{val.value}</div>
            </WizCol>
            :
            <WizCol span={19} md={21} xs={16}>
              {val.value}
              <span style={surveyStatusColor}>{surveyStatus}</span>
            </WizCol>
          }
        </WizRow>
      )
    })
  }

  // 渲染问卷详情统计图表
  renderChart = (val, index) => {
    const header = `${index + 1}.${val.title}`
    return (
      <WizCollapse.Panel key={val.id} header={header} className='panel-item'>
        {
          (val.type || val.type === 0) && [3, 4, 5].indexOf(val.type) !== -1 ?
            this.renderTable(val.items) :
            <WizTabs animated={false} defaultActiveKey="1" type='card'>
              <WizTabs.TabPane tab="表格" key="1">
                {this.renderTable(val.items)}
              </WizTabs.TabPane>
              <WizTabs.TabPane tab="饼状图" key="2">
                {this.renderPie(val.items)}
              </WizTabs.TabPane>
              <WizTabs.TabPane tab="柱状图" key="3">
                {this.renderHistogram(val.items)}
              </WizTabs.TabPane>
            </WizTabs>
        }

      </WizCollapse.Panel>
    )
  }
  //渲染表格图表组件
  renderTable = (items) => {
    const dataItems = getPageData({ records: items })
    const dataTableProps = { columns: columns2(), rowKey: 'selectItem', dataItems }
    return <WizDataTable {...dataTableProps} />
  }
  //渲染饼图组件
  renderPie(items) {
    const data = items.map(val => {
      return { item: val.selectItem, count: val.selectNum, percent: Number(val.proportion) }
    })

    const cols = {
      percent: {
        formatter: val => (val = `${val}%`)
      }
    }

    return (
      <Chart
        width={600}
        height={300}
        data={data}
        scale={cols}
        padding="auto"
      >
        <Coord type="theta" radius={0.75} />
        <Legend position="right" offsetY={-35} offsetX={-60} useHtml
          textStyle={{ fill: 'rgb(51, 51, 51)', fontSize: 12 }}
          containerTpl='<div class="g2-legend"><ul class="g2-legend-list" style="list-style-type:none;margin:0;padding:0;"></ul></div>'
          itemTpl={(value, color, checked, index) => {
            const obj = data[index];
            checked = checked ? "checked" : "unChecked";
            return (
              `<li class="g2-legend-list-item item-${index} ${checked}" data-value="${value}" data-color="${color}" style="cursor: pointer;font-size: 14px;">
                <i class="g2-legend-marker" style="width:10px;height:10px;display:inline-block;margin-right:10px;background-color:${color}"></i>
                <span class="g2-legend-text">{value}</span>
                <i style="color:#ddd; margin:0 10px">|</i>
                <span class="g2-legend-text">${obj.percent}%</span>
                <span class="g2-legend-text" style="margin-left:50px;color:rgba(0, 0, 0, 0.45)">${obj.count}%</span>
              </li>`
            )
          }}
        />
        <Tooltip showTitle={false} />
        <Geom
          type="intervalStack"
          position="percent"
          color="item"
          style={{
            lineWidth: 1,
            stroke: '#fff',
          }}
        />
      </Chart>
    )
  }
  //渲染柱状图组件
  renderHistogram(items) {
    const cols = {
      selectNum: {
        tickInterval: 5
      }
    }

    return (
      <Chart height={400} data={items} scale={cols} forceFit>
        <Axis name="selectItem" />
        <Axis name="selectNum" />
        <Tooltip
          crosshairs={{
            type: "y"
          }}
          itemTpl='<li><span style="background-color:#1890ff;" class="g2-tooltip-marker"></span><span style="margin-right:50px">选择次数</span>{value}</li>'
        />
        <Geom type="interval" position="selectItem*selectNum" />
      </Chart>
    )
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = () => {
    let r = []
    let btns = new Map();
    btns.set('exportQuestionnaireRecord', <WizButton type="primary" title="导出问卷记录" icon="export" style={{ marginBottom: 15 }} onClick={() => this._surveyAnswerExport(this.filters)} >导出问卷记录</WizButton>);
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }

  _render() {
    const { info, surveyRecordLoading, surveyResult, surveyInfo } = this.props;
    const { targetScopeRecord } = this.state
    let columns = columns1(this, info, surveyInfo)
    let list = []
    if (info && info['data'] && info['data']['records'] && info['data']['records'].length) {
      list = getTableData(info['data']['records'])
      info.data.records = list
    }

    let pageList = getPageData(info && info.data)
    let searchBarProps = {
      columns,
      onSearch: values => {
        this.filters = values;
        this._surveyAnswerList(values)
      }
    }

    let dataTableProps = {
      loading: surveyRecordLoading,
      columns,
      rowKey: "id",
      dataItems: pageList,
      showNum: false,
      isScroll: true,
      onChange: ({pageNum,pageSize}) => {
        this._surveyAnswerList({current: pageNum,size: pageSize, ...this.filters})
      }
    }

    return (
      <>
        <WizCard>
          {this.renderDiscriptions()}
        </WizCard>
        <WizCard>
          <WizTabs animated={false} defaultActiveKey="0">
            <WizTabs.TabPane tab="调查受众" key="0">
              {/* <WizSurveyAudience data={targetScopeRecord} labelWidth={4} /> */}
              <AudienceGroupItem { ...targetScopeRecord } />
            </WizTabs.TabPane>
            <WizTabs.TabPane tab="记录列表" key="1">
              <div className='pagination'>
                <WizSearchBar key='surveyRecord_searchBar' type='grid' {...searchBarProps}></WizSearchBar>
              </div>
              {this._renderBtn()}
              <WizDataTable key='surveyRecord_dataTable' {...dataTableProps} />
              <div className='pagination'>
                <WizDataTable.Pagination key={'surveyRecord_pagination'} {...dataTableProps} />
              </div>
            </WizTabs.TabPane>
            {/*<WizTabs.TabPane tab="统计图表" key="2">*/}
            {/*  <WizCollapse className='surveyRecordInfo-collapse' expandIconPosition='right' defaultActiveKey={[1]} >*/}
            {/*    {*/}
            {/*      surveyResult.code === 1 ? surveyResult.data.map((val, index) => this.renderChart(val, index)) : null*/}
            {/*    }*/}
            {/*  </WizCollapse>*/}
            {/*</WizTabs.TabPane>*/}
          </WizTabs>
        </WizCard>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { survey,surveyAnswer } = state;
  const { history } = ownProps;
  const surveyInfo = modelUtils.getModelEntity(survey, "surveyInfo");
  const info = modelUtils.getModelEntity(survey, 'surveyRecordInfo@' + getParamRecord(history).id)
  const surveyAnswerExport = modelUtils.getModelEntity(surveyAnswer, 'surveyAnswer@surveyAnswerList')
  const targetScopeInfo = modelUtils.getModelEntity(survey, "targetScopeInfoKey");
  const result = modelUtils.getModelEntity(survey, "surveyResult@" + getParamRecord(history).id);
  const load = modelUtils.getLoadingState(state, 'surveyRecord');
  return {
    info,
    surveyInfo,
    surveyAnswerExport,
    targetScopeInfo,
    surveyResult: result,
    ...load
  }
};

export default connect(mapStateToProps)(SurveyRecordInfo);
